/**
 * Outgoing Message Content
 *
 * Normalizes user-visible text before chat messages are sent.
 *
 * Primary responsibilities:
 * - Keep local preview blob URLs out of persisted chat text
 * - Preserve normal user text when no preview URL is present
 *
 * Dependencies:
 * - None
 */

const BLOB_URL_PATTERN = /\bblob:[^\s<>"'`)\]]+/gi

// --------------

export function stripBlobUrlsFromOutgoingContent(content: string) {
  const strippedContent = content.replace(BLOB_URL_PATTERN, '')

  if (strippedContent === content) {
    return content
  }

  return strippedContent
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n[ \t]+/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}
